<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="30%" :before-close="handleClose" :closeOnClickModal="false" >
        <el-form label-width="80px" ref="model" :model="model" :rules="rules">
            <el-form-item label="用户ID" prop="UserId">
                <el-input size="small" v-model="model.UserId" auto-complete="off" placeholder="请输入用户ID" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="用户姓名" prop="UserName">
                <el-input size="small" v-model="model.UserName" auto-complete="off" placeholder="请输入姓名" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="用户密码" prop="UserPwd">
                <el-input size="small" v-model="model.UserPwd" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
let validUserId = (rule, value, callback) => {
    let reg = /^[A-Za-z0-9]+$/;
    if (value === '') {
        callback(new Error('请输入用户id'));
    } else if(!reg.test(value)) {
        callback(new Error('用户id只能是数字和字母'))
    } else {
        callback();
    }
};
let validUserPwd = (rule, value, callback) => {
    let reg = /[\u4E00-\u9FA5]/i;
    if (value === '') {
        callback(new Error('请输入密码'));
    } else if(reg.test(value)) {
        callback(new Error('密码不能为中文'))
    } else if(value.length<6){
        callback(new Error('密码长度不能小于6'))
    }else {
        callback();
    }
};
import {AddAdmin} from '../../api/user';
export default {
    data() {
        return {
            title: '添加用户',
            name: 'add',
            model: {
                UserId: '',
                UserName: '',
                UserPwd: ''
            },
            rules: {
                UserId: [{ required: true,  trigger: 'blur',validator: validUserId}],
                UserName: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
                UserPwd: [{ required: true,  trigger: 'blur',validator: validUserPwd}],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        }
    },  
    methods: {
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                        this.AddAdmin()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'error'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeAddDialog')
        },
        AddAdmin() {
            AddAdmin(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        }
    }
}
</script>

<style>

</style>